import N from "../../shared-lib/logger.js";
import { MUST_BE_CARD_WARNING_SUFFIX as P } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import _ from "./card-manager-factory.js";
import { Card } from "./models/index.js";
export function logContentCardClick(o) {
  return (
    !!r.rr() &&
    (o instanceof Card ? _.ea().logClick(o).tt : (N.error("card " + P), !1))
  );
}
